import Button from 'components/Button/Button';
import CountrySelector from 'components/CountrySelector/CountrySelector';
import stateProvider from 'components/CountrySelector/stateProvider';
import countries from 'data/countries';
import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withEventsState, { WithEventsProps } from 'enhancers/withEventsState';
import * as React from 'react';
import Select from 'react-select';
import styled from 'styled-components';

type Props = WithEventsProps & IWithCountryProps & WithColorQueryProps;

const CountrySelect = withEventsState(stateProvider(CountrySelector));

export const EventsFilters: React.SFC<Props> = props => {
  if (props.loading) {
    return null;
  }
  const changeFilter = () => {
    const newFilter = props.events.filter === 'recent' ? 'oldest' : 'recent';
    props.changeFilter({ filter: newFilter });
  };

  const onEventSearchChange = (e: { label: string; value: string }) => {
    props.searchRequest({ type: 'event', text: e.value });
  };

  if (!props.events.eventsSearchText && !props.loading && props.data) {
    if (props.country !== 'global') {
      props.searchRequest({
        text:
          props.data.fetch.Country.Settings &&
          props.data.fetch.Country.Settings.EnglishName
            ? props.data.fetch.Country.Settings.EnglishName
            : props.data.fetch.Country.Name,
        type: 'event'
      });
    }
  }

  return (
    <Container>
      <Filters>
        <StyledButton onClick={changeFilter}>
          {props.events.filter === 'oldest'
            ? 'Oldest First'
            : 'Most Recent First'}
        </StyledButton>
        {props.events.filter === 'country' && <CountrySelect />}
      </Filters>
      <div>
        <StyledSelect
          options={countries.map(country => ({
            label: country,
            value: country
          }))}
          defaultValue={{
            label: countries.find(
              theCountry =>
                theCountry ===
                (!props.loading && props.data
                  ? props.country !== 'global'
                    ? props.data.fetch.Country.Settings &&
                      props.data.fetch.Country.Settings.EnglishName
                      ? props.data.fetch.Country.Settings.EnglishName
                      : props.data.fetch.Country.Name
                    : 'All'
                  : 'All')
            ),
            value: countries.find(
              theCountry =>
                theCountry ===
                (!props.loading && props.data
                  ? props.country !== 'global'
                    ? props.data.fetch.Country.Name
                    : 'All'
                  : 'All')
            )
          }}
          placeholder="Select your country"
          // name="search"
          onChange={onEventSearchChange}
          // value={props.events.eventsSearchText}
          // type="search"
          // nomargin={true}
        />
      </div>
    </Container>
  );
};

const StyledButton = styled(Button)`
  background: rgb(56, 24, 81);
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  @media (max-width: 842px) {
    flex-direction: column;
  }
  color: #333;
`;

const StyledSelect = styled(Select)`
  width: 250px;
`;

const Filters = styled.div`
  display: flex;
  & > * {
    margin-right: 10px;
  }
  align-items: center;
  @media (max-width: 842px) {
    flex-direction: column;
    & > * {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
`;

export default withCountry(withColorQuery(withEventsState(EventsFilters)));



// WEBPACK FOOTER //
// ./src/components/EventsFilters/EventsFilters.tsx